import React from "react";
import { TextProps } from "./props";

const Text = ({ text, ...theme }: TextProps): React.JSX.Element => {
  return (
    <p className={"vcl-text"} {...theme}>
      {text}
    </p>
  );
};

export default Text;
